import React from 'react';
import { FileText } from 'lucide-react';

const ProductDocsTab = ({ ctx }) => {
  return (
<div>
  <h1 className="text-xl font-bold mb-4" style={{ color: '#1A1209' }}>Product Documentation</h1>
  <div className="bg-white rounded-xl p-6" style={{ border: '1px solid #E8E8E8' }}>
    <p className="text-sm text-gray-600 mb-4">Complete reference guides for all HiBFF products. These documents explain how each product works, who it&apos;s for, and the benefits for users.</p>
    <a href="/docs" className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white rounded-lg transition-colors" style={{ backgroundColor: '#5A4A62' }} data-testid="open-docs-btn">
      <FileText size={16} /> Open Product Documentation
    </a>
  </div>
</div>
  );
};

export default ProductDocsTab;
